import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const removeFromCartHandler: ActionHandler = {
  type: 'remove_from_cart',
  execute(ctx) {
    const config = ctx.config;
    // Automatic (BO): productId/variantId may be unset — host resolves from the
    // active cart line. SideCart / PDP emitters still pass explicit identity.
    const productId = readString(config, 'productId', 'product_id') ?? '';
    const variantId = readString(config, 'variantId', 'variant_id') ?? '';
    const lineId = readString(config, 'lineId', 'line_id');
    const port = ctx.semanticPorts?.removeFromCart;
    return invokeSemanticPort(
      ctx,
      'remove_from_cart',
      port
        ? (context) =>
            port(
              {
                productId,
                variantId,
                ...(lineId ? { lineId } : {}),
              },
              context
            )
        : undefined
    );
  },
};
